import { isEmpty } from 'lodash';
import { ALLOWED_EXTERNAL_URL_SCHEMES } from './constants';

export const getSafeExternalUrl = (
    url: string | null | undefined = undefined,
    baseUrl: string | undefined = undefined
): string | null => {
    if (!url) {
        return null;
    }

    try {
        const fallbackBaseUrl = baseUrl || (typeof window !== 'undefined' ? window.location.origin : undefined);
        const parsedUrl = fallbackBaseUrl ? new URL(url, fallbackBaseUrl) : new URL(url);
        return ALLOWED_EXTERNAL_URL_SCHEMES.has(parsedUrl.protocol) ? parsedUrl.href : null;
    } catch {
        return null;
    }
};

export const findLinkIndex = (viewState, link) => {
    return viewState.findIndex(
        (item) =>
            item.referenceName === link.referenceName &&
            item.provider === link.provider &&
            item.storageUrl.path === link.storageUrl.path &&
            item.storageUrl.tldomain === link.storageUrl.tldomain &&
            item.storageUrl.subdomain === link.storageUrl.subdomain
    );
};

export const detectProvider = (url) => {
    const URL_REGEX = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    const providers = {
        'Google Drive': /drive\.google\.com/i,
        Box: /app\.box\.com/i,
        Dropbox: /dropbox\.com/i,
        'Microsoft OneDrive': /onedrive\.live\.com|1drv\.ms/i,
        'AWS S3': /s3\.amazonaws\.com|https?:\/\/[a-z0-9.-]+\.s3\.[a-z0-9-]+\.amazonaws\.com/i,
        iCloud: /icloud\.com/i
    };

    for (const [provider, pattern] of Object.entries(providers)) {
        if (pattern.test(url) && URL_REGEX.test(url) && !isEmpty(url)) {
            return provider;
        }
    }

    return 'Other';
};
